'use client'

import { ReactNode } from 'react'

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
})

export function SentryWrapper({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
